import React, {Component, PropTypes} from 'react'
import {Row, Col, Card, Button} from 'react-materialize';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";

import diving_protection from '../../images/diving_protection.png';

import {CSVLink} from "react-csv";

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import {injectIntl, intlShape} from 'react-intl';
import DatePicker from "react-datepicker";

class ChecklistMergulho extends Component{

    constructor(props){
        super(props);

        this.handleDownloadPDF= this.handleDownloadPDF.bind(this);

        this.showDiv1= this.showDiv1.bind(this);
        this.showDiv2= this.showDiv2.bind(this);
        this.showDiv3= this.showDiv3.bind(this);
        this.showDiv4= this.showDiv4.bind(this);
        this.showDiv5= this.showDiv5.bind(this);

        this.state ={
            showComponent1: false,
            showComponent2: false,
            showComponent3: false,
            showComponent4: false,
            showComponent5: false,

            data: [
                { pergunta: "O equipamento de mergulho foi testado de acordo com as especificações do fabricante?", resposta: "Sim ou não"},
                { pergunta: "Antes de usar o equipamento é realizado uma verificação de funcionamento correto?", resposta: "Sim ou não"},
                { pergunta: "Cada mergulhador está sempre equipado com uma faca forte e afiada; pesos com um mecanismo de liberação rápida para controlar a flutuabilidade; um traje de mergulho ou outra roupa protetora; e proteção adequada da cabeça durante a condução do mergulho?", resposta: "Sim ou não"},
                { pergunta: "Se ocorrer uma avaria ou imprevisibilidade durante um mergulho e não houver substituições disponíveis no local, o mergulho é imediatamente abortado em cooperação com os outros membros da equipe de mergulho?"
                    , resposta: "Sim ou não" },
                { pergunta: "Os membros da equipe de mergulho ao tomarem conhecimento de um mau funcionamento ou risco de equipamento de mergulho no local de mergulho notificam os outros mergulhadores imediatamente?", resposta: "Sim ou não"},

            ],

        }
    }



    handleDownloadPDF = () => {

        window.scrollTo(0,0);

        html2canvas(document.querySelector('#printDiv'), {  allowTaint: true,
            useCORS: true,
            logging: false,
            height: window.outerHeight + window.innerHeight,
            windowHeight: window.outerHeight + window.innerHeight, }).then( function (canvas){


            const imgData = canvas.toDataURL("image/png", 1.0);


            const pdf = new jsPDF("p", "mm", "a4");

            pdf.addImage(imgData, 'PNG', 0,0);
            pdf.save("Checklist.pdf");
        })
    };

    showDiv1 = (e) => {
        this.setState({
            showComponent1: e.target.checked,
        });
    };

    showDiv2 = (e) => {
        this.setState({
            showComponent2: e.target.checked,
        });
    };

    showDiv3 = (e) => {
        this.setState({
            showComponent3: e.target.checked,
        });
    };

    showDiv4 = (e) => {
        this.setState({
            showComponent4: e.target.checked,
        });
    };


    showDiv5 = (e) => {
        this.setState({
            showComponent5: e.target.checked,
        });
    };

    handleChangeDatePicker = date => {
        this.setState({
            startDate: date
        });
    };

    render(){

        const intl= this.props.intl;

        const placeholder = intl.formatMessage({id: 'ph.checklist1', defaultMessage: 'Nome do responsável'});
        const placeholder2 = intl.formatMessage({id: 'ph.checklist2', defaultMessage: 'Data de inspeção:'});
        const placeholder3 = intl.formatMessage({id: 'ph.checklist3', defaultMessage: 'Insira ação corretiva'});

        return(

            <Card>



                <Row>
                    <div className={"text-center"} align="center">
                        <img src={diving_protection} className={"img"} alt={"Aquasafe logo"} width={"100"} height={"100"}/>
                    </div>
                </Row>

                <div id={"printDiv"}>

                <div align={"center"}>
                    <h5><b><FormattedMessage id={"div.ch"} defaultMessage={"Checklist Mergulho"}/></b></h5>
                </div>
                <input type={"text"} placeholder={placeholder} key={"nome"} />

                <React.Fragment>{

                    intl.locale==="en" ?

                        <DatePicker placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                    onChange={this. handleChangeDatePicker}/> :

                        <DatePicker locale={"pt"}  dateFormat="dd/MM/yyyy" placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                    onChange={this. handleChangeDatePicker}/>
                }</React.Fragment>

                    <div className={"printDiv"}>
                        <div className={"margin"}>
                            <b><FormattedMessage id={"div.ch"} defaultMessage={"Checklist Mergulho"}/></b></div>

                        <div>

                            <form action={"#"} className={"formsWorks"}>

                                <p><FormattedMessage id={"div.ch1"} defaultMessage={"O equipamento de mergulho foi testado de acordo com as especificações do fabricante?"}/></p>

                                <input type={"checkbox"} id={"yes1"}/>

                                <label htmlFor={"yes1"} ><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                                <div>
                                    <input type={"checkbox"} id={"no1"} onClick={this.showDiv1}/>

                                    <label htmlFor={"no1"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                                </div>
                                {this.state.showComponent1 ?
                                    <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }


                            </form>
                        </div>

                        <div >
                            <form action={"#"}>

                                <p><FormattedMessage id={"div.ch2"} defaultMessage={"Antes de usar o equipamento é realizado uma verificação de funcionamento correto?"}/></p>

                                <input type={"checkbox"} id={"yes2"}/>

                                <label htmlFor={"yes2"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                                <div>
                                    <input type={"checkbox"} id={"no2"} onClick={this.showDiv2}/>

                                    <label htmlFor={"no2"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                                </div>
                                {this.state.showComponent2 ?
                                    <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                            </form>
                        </div>

                        <div>
                            <form action={"#"}>

                                <p><FormattedMessage id={"div.ch3"} defaultMessage={"Cada mergulhador está sempre equipado com uma faca forte e afiada; pesos com um mecanismo de liberação rápida para controlar a flutuabilidade; um traje de mergulho ou outra roupa protetora; e proteção adequada da cabeça durante a condução do mergulho?"}/></p>

                                <input type={"checkbox"} id={"yes3"}/>

                                <label htmlFor={"yes3"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                                <div>
                                    <input type={"checkbox"} id={"no3"} onClick={this.showDiv3}/>

                                    <label htmlFor={"no3"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                                </div>
                                {this.state.showComponent3 ?
                                    <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                            </form>
                        </div>

                        <div >
                            <form action={"#"}>

                                <p><FormattedMessage id={"div.ch4"} defaultMessage={"Se ocorrer uma avaria ou imprevisibilidade durante um mergulho e não houver substituições disponíveis no local, o mergulho é imediatamente abortado em cooperação com os outros membros da equipe de mergulho?"}/></p>

                                <input type={"checkbox"} id={"yes4"}/>

                                <label htmlFor={"yes4"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                                <div>
                                    <input type={"checkbox"} id={"no4"} onClick={this.showDiv4}/>

                                    <label htmlFor={"no4"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                                </div>
                                {this.state.showComponent4 ?
                                    <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                            </form>
                        </div>

                        <div >
                            <form action={"#"}>

                                <p><FormattedMessage id={"div.ch5"} defaultMessage={"Os membros da equipe de mergulho ao tomarem conhecimento de um mau funcionamento ou risco de equipamento de mergulho no local de mergulho notificam os outros mergulhadores imediatamente?"}/></p>

                                <input type={"checkbox"} id={"yes5"}/>

                                <label htmlFor={"yes5"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                                <div>
                                    <input type={"checkbox"} id={"no5"} onClick={this.showDiv5}/>

                                    <label htmlFor={"no5"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                                </div>
                                {this.state.showComponent5 ?
                                    <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }

                            </form>
                        </div>
                    </div>
                        <br/>

                        <Button className={"button"} onClick={this.handleDownloadPDF} >
                            PDF
                        </Button>


                        <CSVLink data={this.state.data} separator={";"} filename={"checklist.csv"}>
                            <Button className={"button"}>
                                CSV
                            </Button> </CSVLink>
                    </div>




            </Card>

        )
    }
}

export default injectIntl(ChecklistMergulho);